import { render, staticRenderFns } from "./SpeechAlbumDetail.vue?vue&type=template&id=c471c31c&scoped=true&"
import script from "./SpeechAlbumDetail.vue?vue&type=script&lang=js&"
export * from "./SpeechAlbumDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAlbumDetail.vue?vue&type=style&index=0&id=c471c31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c471c31c",
  null
  
)

export default component.exports